import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'

const links = [
  {title: 'Actualizar datos básicos del documento', path: '/documentinformation'},
  {title: 'Actualizar datos del contrato', path: '/contractFields'},
  {title: 'Actualizar datos globales de las notas de venta', path: '/sellNoteFields'},
  {title: 'Actualizar datos avanzados en nota de venta', path: '/DynamicSellNoteSelect'},
  {title: 'Actualizar datos de documento operativo', path: '/operativeDataFields'},
  {title: 'Actualizar datos de anexo ICAM', path: '/iCamFields'},
  {title: 'Actualizar datos de anexo de pŕestamo', path: '/annexedCTO'}
]

@withRouter
export default class RouteMoves extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    docId: PropTypes.string
  }

  renderLinks() {
    return links.map((link, index) => {
      const isActive = this.props.router.location.pathname.endsWith(`${link.path}`)
      return (
        <div key={index} className={styles.links}>
          <div onClick={link.onClick} className={isActive ? styles.active : styles.inactive}>
            <div
              className={styles.title}
              onClick={() => this.props.router.push(`/preparation/${this.props.docId}${link.path}`)}
            >
              {link.title}
            </div>
          </div>
        </div>
      )
    })
  }

  render() {
    return <div>{this.renderLinks()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/RouteMoves/index.js